export default "<template>\r\n  <v-file-input show-size counter multiple label=\"File input\"></v-file-input>\r\n</template>\r\n";